<template>
  <div class="modal" v-show="fathertoson.show">
    <div class="modal_dialog">
        <div class="modal_top">
            <p class="tip_content">{{fathertoson.content}}</p>
        </div>
        <div class="modal_bottom" v-if="(!fathertoson.cancelText)&&fathertoson.okText != '确定'">
            <div class="tip_button" @click="cancel()">{{fathertoson.okText}}</div>
        </div>
        <div class="modal_bottom" v-if="fathertoson.okText == '确定'">
            <div class="tip_button" @click="close()">{{fathertoson.okText}}</div>
        </div>
        <div class="modal_bottom cancel" v-if="fathertoson.cancelText">
            <div class="tip_button exit" @click="cancel()">{{fathertoson.cancelText}}</div>
            <div class="tip_button sure" @click="ok()">{{fathertoson.okText}}</div>
        </div>
    </div>
   </div>
</template>
<script>
   export default {
    props:["fathertoson"],
   	methods:{
        ok:function(){
            this.fathertoson.ok();
        },
        cancel:function(){
            this.fathertoson.cancel();
        },
        close:function(){
            this.fathertoson.close();
        }
   	},
    created(){
        // var contentString = $('.tip_content').html()
        // var contentArray = contentString.split(',')
        // var oP = $("<p>"+contentArray[0]+"</p>")
        // for(var i = 0 ;i<contentArray.lenght;i++){
            
        // }
    },
    mounted(){

    }
   }
</script>
<style type="text/css" lang="scss" scoped>
    .modal{
        width:100%;
        height:100%;
        background-color:rgba(0,6,36,0.8);
        position:fixed;
        z-index:2002;
        .modal_dialog{
            position:fixed;
            z-index:2003;
            top:0px;
            width:392px;
            height:240px;
            background-color:#fff;
            top:50%;
            left:50%;
            margin-left:-214px;
            margin-top:-135px;
            .modal_top{
                width:392px;
                height:160px;
                background-color:#6699ff;
                text-align:center;
                vertical-align:middle;
                display: table-cell;
                .tip_content{
                    font-size:18px;
                    color:#fff;
                    font-family:"宋体";
                    line-height:32px;
                }
            }
            .modal_bottom{
                width:100%;
                text-align:center;
                height:80px;
                .tip_button{
                    width:100%;
                    color:#6699ff;
                    font-size:16px;
                    font-family:"宋体";
                    line-height:80px;
                    font-weight:400;
                    text-align:center;
                    cursor: pointer;
                }
                &.cancel{
                    width: 100%;
                    overflow: hidden;
                    .tip_button{
                        float: left;
                        width: 50%;
                        height:80px;
                        &.exit{
                            color:#999;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// modal.vue?22e39ab1